module.exports = __webpack_public_path__ + "static/media/open-training.1f029d5c.svg";